import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityStatusDashboard = ({ activeThreats, accessViolations, auditLogVolume, complianceScore, loading }) => {
  const metrics = [
    {
      label: 'Active Threats',
      value: activeThreats,
      icon: 'AlertTriangle',
      color: activeThreats > 0 ? 'red' : 'green',
      bgColor: activeThreats > 0 ? 'bg-red-50' : 'bg-green-50',
      iconColor: activeThreats > 0 ? 'text-red-600' : 'text-green-600',
      textColor: activeThreats > 0 ? 'text-red-900' : 'text-green-900'
    },
    {
      label: 'Access Violations',
      value: accessViolations,
      icon: 'ShieldAlert',
      color: accessViolations > 0 ? 'orange' : 'green',
      bgColor: accessViolations > 0 ? 'bg-orange-50' : 'bg-green-50',
      iconColor: accessViolations > 0 ? 'text-orange-600' : 'text-green-600',
      textColor: accessViolations > 0 ? 'text-orange-900' : 'text-green-900'
    },
    {
      label: 'Audit Log Volume',
      value: auditLogVolume?.toLocaleString(),
      icon: 'FileText',
      color: 'blue',
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600',
      textColor: 'text-blue-900'
    },
    {
      label: 'Compliance Score',
      value: `${complianceScore}%`,
      icon: 'Shield',
      color: complianceScore >= 95 ? 'green' : complianceScore >= 80 ? 'yellow' : 'red',
      bgColor: complianceScore >= 95 ? 'bg-green-50' : complianceScore >= 80 ? 'bg-yellow-50' : 'bg-red-50',
      iconColor: complianceScore >= 95 ? 'text-green-600' : complianceScore >= 80 ? 'text-yellow-600' : 'text-red-600',
      textColor: complianceScore >= 95 ? 'text-green-900' : complianceScore >= 80 ? 'text-yellow-900' : 'text-red-900'
    }
  ];

  if (loading) {
    return (
      <>
        {[1, 2, 3, 4]?.map(i => (
          <div key={i} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-3/4"></div>
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {metrics?.map((metric, index) => (
        <div key={index} className={`${metric?.bgColor} rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 flex flex-col`}>
          <div className="flex items-center justify-between mb-3 sm:mb-4 gap-2">
            <h3 className="text-xs sm:text-sm font-medium text-gray-600 break-words flex-1">{metric?.label}</h3>
            <Icon name={metric?.icon} className={`w-5 h-5 sm:w-6 sm:h-6 ${metric?.iconColor} flex-shrink-0`} />
          </div>
          <p className={`text-2xl sm:text-3xl font-bold ${metric?.textColor} break-words`}>{metric?.value}</p>
        </div>
      ))}
    </>
  );
};

export default SecurityStatusDashboard;